import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchCustomerRouteList = createAsyncThunk("fetchCustomerRouteList", async (user_channel, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.get(`routes?channel_id=${user_channel}`);
		return response.data.data;
	} catch (error) {
		return rejectWithValue(error.response?.data?.message || "Something went wrong while fetching the route list");
	}
});

const RewardCustomerRoutesSlice = createSlice({
	name: "RewardCustomerRoutesSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchCustomerRouteList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchCustomerRouteList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});

		builder.addCase(fetchCustomerRouteList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload || action.error.message || "Unknown error occurred";
		});
	},
});

export default RewardCustomerRoutesSlice.reducer;
